// «التحليل الذكي» strings. Merged into translations by i18n.js.
// Keys are ai_* (plus the permission-editor group label); both languages carry the same key set.
export const AI_STRINGS = {
    ar: {
        perm_cap_group_ai: "التحليل الذكي",
        ai_title: "التحليل الذكي",
        ai_subtitle: "ملخصات وتوصيات من بيانات النظام كاملة، يكتبها الذكاء الاصطناعي من أرقام محسوبة مسبقًا",
        ai_key_missing: "لم يتم ضبط مفتاح الذكاء الاصطناعي",
        ai_key_missing_hint: "يضبط المالك المفتاح ANTHROPIC_API_KEY في إعدادات النشر، ثم تبدأ التحليلات تلقائيًا.",
        ai_run_now: "تحديث الآن",
        ai_running: "جارٍ إعداد التحليل… قد يستغرق بضع دقائق",
        ai_run_started: "بدأ إعداد التحليل",
        ai_cooldown_until: "التحديث التالي متاح بعد {m} دقيقة",
        ai_period_day: "يومي",
        ai_period_week: "أسبوعي",
        ai_period_month: "شهري",
        ai_kind_daily: "يومي",
        ai_kind_weekly: "أسبوعي",
        ai_kind_monthly: "شهري",
        ai_kind_on_demand: "عند الطلب",
        ai_status_done: "مكتمل",
        ai_status_failed: "تعذر",
        ai_status_running: "قيد الإعداد",
        ai_status_queued: "في الانتظار",
        ai_tab_executive: "الملخص التنفيذي",
        ai_tab_advice: "التوصيات",
        ai_tab_modules: "حسب القسم",
        ai_tab_branches: "حسب الفرع",
        ai_tab_quality: "جودة البيانات",
        ai_tab_history: "السجل",
        ai_generated: "أُعد في",
        ai_period: "الفترة",
        ai_model: "النموذج",
        ai_tokens: "الرموز",
        ai_cost: "التكلفة التقديرية",
        ai_month_spend: "تكلفة هذا الشهر",
        ai_mode_batch: "دفعة مجدولة (نصف السعر)",
        ai_mode_realtime: "فوري",
        ai_no_brief: "لا يوجد تحليل بعد",
        ai_no_brief_hint: "يُعد أول تحليل يومي تلقائيًا بعد سحب المبيعات الصباحي، أو اضغط «تحديث الآن».",
        ai_choose_brief: "اختر التحليل",
        ai_choose_branch: "اختر الفرع",
        ai_network: "الشبكة",
        ai_priority: "الأولوية",
        ai_impact_high: "أثر عالٍ",
        ai_impact_medium: "أثر متوسط",
        ai_impact_low: "أثر منخفض",
        ai_horizon_today: "اليوم",
        ai_horizon_this_week: "هذا الأسبوع",
        ai_horizon_this_month: "هذا الشهر",
        ai_action: "الإجراء",
        ai_why: "السبب",
        ai_advice_super_only: "التوصيات تظهر للمدير الأعلى فقط",
        ai_no_advice: "لا توجد توصيات صالحة في هذا التحليل",
        ai_unverified: "رقم غير موجود في بيانات النظام — تحقق منه",
        ai_flagged_items: "عناصر فيها أرقام غير متحقق منها",
        ai_rejected_items: "عناصر رُفضت لأنها تستشهد بأرقام غير موجودة",
        ai_caveats: "تنبيهات البيانات",
        ai_no_caveats: "لا توجد تنبيهات على البيانات",
        ai_modules_status: "حالة جمع البيانات",
        ai_module_ok: "متوفر",
        ai_module_empty: "لا بيانات",
        ai_module_error: "تعذر",
        ai_part_detail: "التحليل المفصل",
        ai_part_executive: "الملخص التنفيذي",
        ai_part_advice: "التوصيات",
        ai_part_missing: "لم يُكتب هذا الجزء من التحليل",
        ai_detail_missing_hint: "بيانات الأقسام نفسها جُمعت — انظر «جودة البيانات». يمكن إعادة المحاولة بـ«تحديث الآن».",
        ai_not_written: "أقسام جُمعت بياناتها ولم يُكتب تحليلها",
        ai_status_partial: "مكتمل جزئيًا",
        ai_open_screen: "افتح الشاشة",
        ai_failed: "تعذر إعداد هذا التحليل",
        ai_partial: "اكتمل جزء من التحليل فقط",
        ai_retry_hint: "يمكن المحاولة مرة أخرى بـ«تحديث الآن».",
        ai_severity_high: "مهم",
        ai_severity_warn: "تنبيه",
        ai_severity_info: "معلومة",
        ai_settings: "إعدادات التحليل",
        ai_set_exec_model: "نموذج الملخص والتوصيات",
        ai_set_detail_model: "نموذج التفاصيل",
        ai_set_daily: "تحليل يومي",
        ai_set_weekly: "تحليل أسبوعي",
        ai_set_monthly: "تحليل شهري",
        ai_set_batch: "المجدولة عبر الدفعات (نصف السعر)",
        ai_set_cooldown: "فترة الانتظار بين التحديثات (دقيقة)",
        ai_set_budget: "حد التكلفة الشهري (دولار)",
        ai_save: "حفظ",
        ai_saved: "تم الحفظ",
        ai_schedule_note: "اليومي بعد سحب المبيعات الساعة 5 صباحًا (أو 6 صباحًا كحد أقصى)، الأسبوعي يوم الأحد، الشهري يوم 3 من الشهر. المجدولة تُرسل كدفعة بنصف السعر وقد تستغرق حتى ساعة أو أكثر؛ «تحديث الآن» فوري.",
        ai_points_none: "لا توجد نقاط",
        ai_unit_SAR: "ر.س",
        ai_unit_pct: "٪",
        ai_unit_days: "يوم",
        ai_unit_minutes: "دقيقة",
        ai_unit_hours: "ساعة",
        ai_unit_kg: "كجم",
        ai_unit_pcs: "حبة",
    },
    en: {
        perm_cap_group_ai: "AI analysis",
        ai_title: "AI Analysis",
        ai_subtitle: "Summaries and recommendations across the whole system, written by AI from pre-computed figures",
        ai_key_missing: "The AI key has not been set",
        ai_key_missing_hint: "The owner sets ANTHROPIC_API_KEY in the deployment settings; briefs then start automatically.",
        ai_run_now: "Refresh now",
        ai_running: "Preparing the analysis… this can take a few minutes",
        ai_run_started: "The analysis has started",
        ai_cooldown_until: "Next refresh available in {m} min",
        ai_period_day: "Daily",
        ai_period_week: "Weekly",
        ai_period_month: "Monthly",
        ai_kind_daily: "Daily",
        ai_kind_weekly: "Weekly",
        ai_kind_monthly: "Monthly",
        ai_kind_on_demand: "On demand",
        ai_status_done: "Done",
        ai_status_failed: "Failed",
        ai_status_running: "Preparing",
        ai_status_queued: "Queued",
        ai_tab_executive: "Executive summary",
        ai_tab_advice: "Recommendations",
        ai_tab_modules: "By module",
        ai_tab_branches: "By branch",
        ai_tab_quality: "Data quality",
        ai_tab_history: "History",
        ai_generated: "Generated",
        ai_period: "Period",
        ai_model: "Model",
        ai_tokens: "Tokens",
        ai_cost: "Estimated cost",
        ai_month_spend: "This month's spend",
        ai_mode_batch: "Scheduled batch (half price)",
        ai_mode_realtime: "Real time",
        ai_no_brief: "No analysis yet",
        ai_no_brief_hint: "The first daily brief is prepared automatically after the morning sales pull, or press «Refresh now».",
        ai_choose_brief: "Choose a brief",
        ai_choose_branch: "Choose a branch",
        ai_network: "Network",
        ai_priority: "Priority",
        ai_impact_high: "High impact",
        ai_impact_medium: "Medium impact",
        ai_impact_low: "Low impact",
        ai_horizon_today: "Today",
        ai_horizon_this_week: "This week",
        ai_horizon_this_month: "This month",
        ai_action: "Action",
        ai_why: "Why",
        ai_advice_super_only: "Recommendations are visible to the super admin only",
        ai_no_advice: "No valid recommendations in this brief",
        ai_unverified: "A number not found in the system data — check it",
        ai_flagged_items: "Items with unverified numbers",
        ai_rejected_items: "Items rejected for citing figures that do not exist",
        ai_caveats: "Data caveats",
        ai_no_caveats: "No caveats on the data",
        ai_modules_status: "Data collection status",
        ai_module_ok: "Available",
        ai_module_empty: "No data",
        ai_module_error: "Failed",
        ai_part_detail: "Detailed analysis",
        ai_part_executive: "Executive summary",
        ai_part_advice: "Recommendations",
        ai_part_missing: "This part of the brief was not written",
        ai_detail_missing_hint: "The modules' data itself was collected — see «Data quality». You can try again with «Refresh now».",
        ai_not_written: "Modules whose data was collected but whose analysis was not written",
        ai_status_partial: "Partly done",
        ai_open_screen: "Open screen",
        ai_failed: "This brief could not be prepared",
        ai_partial: "Only part of the brief was completed",
        ai_retry_hint: "You can try again with «Refresh now».",
        ai_severity_high: "Important",
        ai_severity_warn: "Warning",
        ai_severity_info: "Info",
        ai_settings: "Analysis settings",
        ai_set_exec_model: "Summary & advice model",
        ai_set_detail_model: "Detail model",
        ai_set_daily: "Daily brief",
        ai_set_weekly: "Weekly brief",
        ai_set_monthly: "Monthly brief",
        ai_set_batch: "Scheduled via batches (half price)",
        ai_set_cooldown: "Cooldown between refreshes (minutes)",
        ai_set_budget: "Monthly cost cap (USD)",
        ai_save: "Save",
        ai_saved: "Saved",
        ai_schedule_note: "Daily after the 05:00 sales pull (06:00 at the latest), weekly on Sunday, monthly on day 3. Scheduled briefs go as a half-price batch and can take an hour or more; «Refresh now» is real time.",
        ai_points_none: "No points",
        ai_unit_SAR: "SAR",
        ai_unit_pct: "%",
        ai_unit_days: "days",
        ai_unit_minutes: "min",
        ai_unit_hours: "h",
        ai_unit_kg: "kg",
        ai_unit_pcs: "pcs",
    },
};
